import gql from 'graphql-tag';

export default gql`
    query GetFilteredAssetLoadManagements($input: GetFilteredAssetLoadListInput, $offset: Int) {
        getFilteredAssetLoadManagements(input: $input, offset: $offset) {
            loadId
            carrierName
            driverName
            origin
            destination
            trailerType
            status
            assetLoadType
            atOriginIn
            atOriginOut
            atDestinationIn
            atDestinationOut
            equipments
            mobId
            truckNumber
            payCode
            miles
            accessorialCost
            originAddress
            destinationAddress
            customer
            jobName
            region
            district
            districtAbbreviation
            kronosId
            comments
        }
    }
`;